import { defineComponent as _defineComponent } from 'vue'
import localforage from 'localforage'
import {
  nextTick,
  onBeforeMount,
  onBeforeUnmount,
  reactive,
  ref,
  watch
} from 'vue'
import { useEventListener } from '@vueuse/core'
import { emitter } from '@/plugins/emitter'

type CssSize = Record<string, string>
type FormatData = Record<string, unknown>
type PreviewVm = {
  $el?: HTMLElement
  $refs?: { previewMain?: HTMLElement }
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AllPreviewDialog',
  setup(__props) {

/**
 * 書式プレビューダイアログ（vue-final-modal）。
 * open は mitt（open-all-preview-dialog）。戻るは window popstate（VueUse）。
 * vue-js-modal / event bus は使わない。IndexedDB は localforage 明示 import。
 */
const OPEN_ALL_PREVIEW_DIALOG = 'open-all-preview-dialog'
const DOC_PAPER_HEIGHT_PX = 794

const visible = ref(false)
const formatData = reactive<FormatData>({})
const backupDataViewerCssRirekisho = ref<CssSize>({})
const backupDataViewerCssShokurekisho = ref<CssSize>({})
const previewScale = ref(1)
const activePreviewTab = ref('basic_send_data')
const rirekishoPreview = ref<PreviewVm | null>(null)
const shokurekishoPreview = ref<PreviewVm | null>(null)
const letterPreview = ref<PreviewVm | null>(null)

function onVisibleInput(value: boolean) {
  visible.value = value
}

function closeAllPreviewDialog() {
  visible.value = false
}

function activeViewer(): PreviewVm | null {
  if (activePreviewTab.value === 'format_rirekisho') {
    return rirekishoPreview.value
  }
  if (activePreviewTab.value === 'format_shokumukeirekisho') {
    return shokurekishoPreview.value
  }
  if (activePreviewTab.value === 'format_letter') {
    return letterPreview.value
  }
  return null
}

function setPreviewHeight() {
  const height =
    activeViewer()?.$refs?.previewMain?.getBoundingClientRect().height
  if (!height) return
  if (activePreviewTab.value === 'format_rirekisho' && height > 0) {
    backupDataViewerCssRirekisho.value = {
      height: height + 30 + 'px'
    }
  } else if (
    activePreviewTab.value === 'format_shokumukeirekisho' &&
    height > 0
  ) {
    backupDataViewerCssShokurekisho.value = {
      height: height + 30 + 'px'
    }
  } else if (activePreviewTab.value === 'format_letter' && height > 0) {
    backupDataViewerCssShokurekisho.value = {
      height: height + 30 + 'px'
    }
  }
}

function setPreviewScale() {
  nextTick(() => {
    const el = activeViewer()?.$el
    if (el && el.clientWidth !== 0) {
      const clientWidth = el.clientWidth
      previewScale.value =
        clientWidth / Math.max(clientWidth, DOC_PAPER_HEIGHT_PX)
      console.log(clientWidth, previewScale.value)
    }
    nextTick(() => {
      setPreviewHeight()
    })
  })
}

function onTabClick() {
  setPreviewScale()
}

function loadFormatData() {
  localforage
    .iterate((value, key) => {
      formatData[key] = value
    })
    .catch((err) => {
      if (err) console.error(err)
    })
}

function openAllPreviewDialog() {
  console.error(formatData)
  loadFormatData()
  visible.value = true
}

watch(visible, (open) => {
  if (!open) return
  setPreviewScale()
})

useEventListener(window, 'popstate', closeAllPreviewDialog)

onBeforeMount(() => {
  loadFormatData()
  emitter.on(OPEN_ALL_PREVIEW_DIALOG, openAllPreviewDialog)
})

onBeforeUnmount(() => {
  emitter.off(OPEN_ALL_PREVIEW_DIALOG, openAllPreviewDialog)
})

return { __sfc: true,OPEN_ALL_PREVIEW_DIALOG, DOC_PAPER_HEIGHT_PX, visible, formatData, backupDataViewerCssRirekisho, backupDataViewerCssShokurekisho, previewScale, activePreviewTab, rirekishoPreview, shokurekishoPreview, letterPreview, onVisibleInput, closeAllPreviewDialog, activeViewer, setPreviewHeight, setPreviewScale, onTabClick, loadFormatData, openAllPreviewDialog }
}

})